// import React, { useEffect, useState } from 'react';
// import './DealOfMonth.css';
// import CMSHead from '../../UI-Controls/CMSHead/CMSHead';
// import InfoPopUp from '../../InfoPopUp/InfoPopUp';
// import axios from 'axios';
// import { security_key, Url } from '../../../Services/Api';
// import Datetime from 'react-datetime';
// import 'react-datetime/css/react-datetime.css';
// import SectionLoader from '../../UI-Controls/MainLoader/SectionLoader';
// import { IoClose } from "react-icons/io5";


// const DealOfMonth = ({ handleOpen }) => {
//   const [infoModal, setInfoModal] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [selectedDate, setSelectedDate] = useState(null);

//   const [searchTerm, setSearchTerm] = useState('');
//   const [searchResults, setSearchResults] = useState([]);
//   const [searchLoading, setSearchLoading] = useState(false);
//   const [showResults, setShowResults] = useState(false);

//   const [selectedProducts, setSelectedProducts] = useState([]); // NEW: selected products

//   // Fetch existing Deal of the Month data
//   useEffect(() => {
//     const getDealData = async () => {
//       try {
//         const response = await axios.get(`${Url}/api/v1/deal_of_the_month/getDealOfTheMonthTime`);
//         if (response.status === 200) {
//           const data = response.data.data;
//           if (data.datetime) setSelectedDate(new Date(data.datetime));
//           if (data.products) setSelectedProducts(data.products); // load previously selected products
//         }
//       } catch (error) {
//         console.error('Unexpected Error', error);
//       }
//     };
//     getDealData();
//   }, []);

//   const handleShowInfoModal = () => setInfoModal(true);
//   const handleCloseInfoModal = () => setInfoModal(false);

//   // Handle date change
//   const handleChange = (date) => {
//     if (date && date.isValid()) {
//       setSelectedDate(date.toISOString());
//     }
//   };

//   // Handle product search
//   useEffect(() => {
//     if (!searchTerm.trim()) {
//       setSearchResults([]);
//       return;
//     }

//     const delayDebounce = setTimeout(async () => {
//       try {
//         setSearchLoading(true);
//         const res = await fetch(
//           `${Url}/api/v1/products/by-name?name=${searchTerm}&deal_of_month=1&page=1&limit=100`
//         );
//         const data = await res.json();
//         setSearchResults(data?.products || []);
//         setShowResults(true);
//       } catch (error) {
//         console.error('Search error:', error);
//       } finally {
//         setSearchLoading(false);
//       }
//     }, 500);

//     return () => clearTimeout(delayDebounce);
//   }, [searchTerm]);

//   // Handle product selection (toggle)
//   const handleSelectProduct = (product) => {
//     setSelectedProducts((prev) => {
//       const exists = prev.find((p) => p._id === product._id);
//       if (exists) {
//         // Remove if already selected
//         return prev.filter((p) => p._id !== product._id);
//       } else {
//         return [...prev, product];
//       }
//     });
//   };

//   // Send datetime and product IDs to backend
//   const handleSendDateTimeDatabase = async () => {
//     const api = `/api/v1/deal_of_the_month/dealOfTheMonthSet`;
//     const token = sessionStorage.getItem('authToken');
//     const headers = {
//       Authorization: `Bearer ${token}`,
//       'x-api-key': security_key,
//     };

//     const payload = {};
//     if (selectedDate) payload.datetime = new Date(selectedDate).toISOString();
//     if (selectedProducts.length > 0) payload.products = selectedProducts.map((p) => p._id);

//     try {
//       setLoading(true);
//       const response = await axios.post(`${Url + api}`, payload, { headers });
//       if (response.status === 200 || response.status === 201) {
//         handleOpen('Deal of the Month updated successfully!');
//       } else {
//         handleOpen('Unexpected Status Code Error');
//       }
//     } catch (error) {
//       console.error('Unexpected Server Error', error);
//       handleOpen('Unexpected Server Error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className='deal-of-month-main-container'>
//       {loading && <SectionLoader />}

//       <CMSHead
//         heading={'Deal Of The Month'}
//         buttonText={'Save'}
//         isButtonVissible={true}
//         sendImagesHomeSlider={handleSendDateTimeDatabase}
//         handleShowInfoModal={handleShowInfoModal}
//       />

//       <div className='deal-of-the-month-main-container'>
//         <div className='deal-of-the-month-main-container-left'>
//           <Datetime
//             value={selectedDate ? new Date(selectedDate) : null}
//             onChange={handleChange}
//             dateFormat='YYYY-MM-DD'
//             timeFormat='hh:mm a'
//             inputProps={{
//               placeholder: 'Select Date and Time',
//               className: 'custom-input',
//             }}
//             className='custom-datetime'
//           />

//           {/* Search Products */}
//           <div className='flyer_2_product_searchbar-search-cont' style={{ position: 'relative' }}>
//             <p>Search Product</p>
//             <input
//               type='text'
//               placeholder='Search Furniture Depots'
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               onFocus={() => setShowResults(true)}
//             />

//             {showResults && (
//               <div className='search_results_dropdown'>
//                 {searchLoading && <p>Loading...</p>}
//                 {!searchLoading && searchResults.length === 0 && <p>No products found</p>}

//                 {searchResults.map((product) => {
//                   const isSelected = selectedProducts.find((p) => p._id === product._id);
//                   return (
//                     <div
//                       key={product._id}
//                       className={`search_result_item ${isSelected ? 'selected' : ''}`}
//                       onClick={() => handleSelectProduct(product)}
//                     >
//                       <img src={Url + product.image?.image_url} alt={product.name} />
//                       <div>
//                         <p>{product.name}</p>
//                         <span>${product.sale_price}</span>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Selected Products */}
//         {selectedProducts.length > 0 && (
//           <div className='selected_products_container'>
//             <div className='selected_products_list'>
//               {selectedProducts.map((product) => (
//                 <div key={product._id} className='selected_product_item_DOM'>
//                   <img src={Url + product.image?.image_url} alt={product.name} />
//                   <p>{product.name}</p>

//                   <div className='price_section_dom'>
//                     <h4>${product.sale_price}</h4>
//                     <del>${product.regular_price}</del>
//                   </div>
//                   <button onClick={() => handleSelectProduct(product)}><IoClose /></button>
//                   <span className='dom_card_sku'>SKU : {product.sku}</span>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>

//       <InfoPopUp showInfoModal={infoModal} handleCloseInfoModal={handleCloseInfoModal} />
//     </div>
//   );
// };

// export default DealOfMonth;



import React, { useEffect, useState } from 'react';
import './DealOfMonth.css';
import CMSHead from '../../UI-Controls/CMSHead/CMSHead';
import InfoPopUp from '../../InfoPopUp/InfoPopUp';
import axios from 'axios';
import { security_key, Url } from '../../../Services/Api';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import SectionLoader from '../../UI-Controls/MainLoader/SectionLoader';
import { IoClose } from "react-icons/io5";
import { DndContext, closestCenter } from "@dnd-kit/core";
import { SortableContext, arrayMove, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";


const DealOfMonth = ({ handleOpen }) => {
  const [infoModal, setInfoModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [showResults, setShowResults] = useState(false);

  const [selectedProducts, setSelectedProducts] = useState([]); // NEW: selected products

  // Fetch existing Deal of the Month data
  useEffect(() => {
    const getDealData = async () => {
      try {
        const response = await axios.get(`${Url}/api/v1/deal_of_the_month/getDealOfTheMonthTime`);
        if (response.status === 200) {
          const data = response.data.data;
          if (data.datetime) setSelectedDate(new Date(data.datetime));
          if (data.products) setSelectedProducts(data.products); // load previously selected products
        }
      } catch (error) {
        console.error('Unexpected Error', error);
      }
    };
    getDealData();
  }, []);

  const handleShowInfoModal = () => setInfoModal(true);
  const handleCloseInfoModal = () => setInfoModal(false);

  // Handle date change
  const handleChange = (date) => {
    if (date && date.isValid()) {
      setSelectedDate(date.toISOString());
    }
  };

  // Handle product search
  useEffect(() => {
    if (!searchTerm.trim()) {
      setSearchResults([]);
      return;
    }

    const delayDebounce = setTimeout(async () => {
      try {
        setSearchLoading(true);
        const res = await fetch(
          `${Url}/api/v1/products/by-name?name=${searchTerm}&deal_of_month=1&page=1&limit=100`
        );
        const data = await res.json();
        setSearchResults(data?.products || []);
        setShowResults(true);
      } catch (error) {
        console.error('Search error:', error);
      } finally {
        setSearchLoading(false);
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  // Handle product selection (toggle)
  const handleSelectProduct = (product) => {
    setSelectedProducts((prev) => {
      const exists = prev.find((p) => p._id === product._id);
      if (exists) {
        // Remove if already selected
        return prev.filter((p) => p._id !== product._id);
      } else {
        return [...prev, product];
      }
    });
  };

  // Send datetime and product IDs to backend
  const handleSendDateTimeDatabase = async () => {
    const api = `/api/v1/deal_of_the_month/dealOfTheMonthSet`;
    const token = sessionStorage.getItem('authToken');
    const headers = {
      Authorization: `Bearer ${token}`,
      'x-api-key': security_key,
    };

    const payload = {};
    if (selectedDate) payload.datetime = new Date(selectedDate).toISOString();
    if (selectedProducts.length > 0) payload.products = selectedProducts.map((p) => p._id);

    try {
      setLoading(true);
      const response = await axios.post(`${Url + api}`, payload, { headers });
      if (response.status === 200 || response.status === 201) {
        handleOpen('Deal of the Month updated successfully!');
      } else {
        handleOpen('Unexpected Status Code Error');
      }
    } catch (error) {
      console.error('Unexpected Server Error', error);
      handleOpen('Unexpected Server Error');
    } finally {
      setLoading(false);
    }
  };

  // const SortableProduct = ({ product, handleSelectProduct, Url }) => {
  //   const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: product._id });

  //   const style = {
  //     transform: CSS.Transform.toString(transform),
  //     transition,
  //     cursor: 'grab',
  //   };

  //   return (
  //     <div ref={setNodeRef} style={style} {...attributes} {...listeners} className="selected_product_item_DOM">
  //       <img src={Url + product.image?.image_url} alt={product.name} />
  //       <p>{product.name}</p>

  //       <div className="price_section_dom">
  //         <h4>${product.sale_price}</h4>
  //         <del>${product.regular_price}</del>
  //       </div>

  //       <button
  //         onClick={(e) => {
  //           e.stopPropagation(); // prevent drag from intercepting
  //           handleSelectProduct(product);
  //         }}
  //       >
  //         <IoClose />
  //       </button>

  //       <span className="dom_card_sku">SKU : {product.sku}</span>
  //     </div>
  //   );
  // };


const SortableProduct = ({ product, handleSelectProduct, Url }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: product._id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: 'grab',
  };

  return (
    <div ref={setNodeRef} style={style} className="selected_product_item_DOM">
      {/* 🔹 Only this div is draggable */}
      <div {...attributes} {...listeners} style={{ cursor: 'grab' }}>
        <img src={Url + product.image?.image_url} alt={product.name} />
        <p>{product.name}</p>
        <div className="price_section_dom">
          <h4>${product.sale_price}</h4>
          <del>${product.regular_price}</del>
        </div>
      </div>

      {/* 🔹 Delete button is completely outside drag listeners */}
      <button onClick={() => handleSelectProduct(product)}>
        <IoClose />
      </button>

      <span className="dom_card_sku">SKU : {product.sku}</span>
    </div>
  );
};
  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    setSelectedProducts((items) => {
      const oldIndex = items.findIndex((i) => i._id === active.id);
      const newIndex = items.findIndex((i) => i._id === over.id);
      return arrayMove(items, oldIndex, newIndex);
    });
  };

  return (
    <div className='deal-of-month-main-container'>
      {loading && <SectionLoader />}

      <CMSHead
        heading={'Deal Of The Month'}
        buttonText={'Save'}
        isButtonVissible={true}
        sendImagesHomeSlider={handleSendDateTimeDatabase}
        handleShowInfoModal={handleShowInfoModal}
      />

      <div className='deal-of-the-month-main-container'>
        <div className='deal-of-the-month-main-container-left'>
          <Datetime
            value={selectedDate ? new Date(selectedDate) : null}
            onChange={handleChange}
            dateFormat='YYYY-MM-DD'
            timeFormat='hh:mm a'
            inputProps={{
              placeholder: 'Select Date and Time',
              className: 'custom-input',
            }}
            className='custom-datetime'
          />

          {/* Search Products */}
          <div className='flyer_2_product_searchbar-search-cont' style={{ position: 'relative' }}>
            <p>Search Product</p>
            <input
              type='text'
              placeholder='Search Furniture Depots'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onFocus={() => setShowResults(true)}
            />

            {showResults && (
              <div className='search_results_dropdown'>
                {searchLoading && <p>Loading...</p>}
                {!searchLoading && searchResults.length === 0 && <p>No products found</p>}

                {searchResults.map((product) => {
                  const isSelected = selectedProducts.find((p) => p._id === product._id);
                  return (
                    <div
                      key={product._id}
                      className={`search_result_item ${isSelected ? 'selected' : ''}`}
                      onClick={() => handleSelectProduct(product)}
                    >
                      <img src={Url + product.image?.image_url} alt={product.name} />
                      <div>
                        <p>{product.name}</p>
                        <span>${product.sale_price}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
        {selectedProducts.length > 0 && (
          <div className='selected_products_container'>
            <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
              <SortableContext items={selectedProducts.map(p => p._id)} strategy={verticalListSortingStrategy}>
                <div className='selected_products_list'>
                  {selectedProducts.map((product) => (
                    <SortableProduct
                      key={product._id}
                      product={product}
                      Url={Url}
                      handleSelectProduct={handleSelectProduct}
                    />
                  ))}
                </div>
              </SortableContext>
            </DndContext>
          </div>
        )}
      </div>

      <InfoPopUp showInfoModal={infoModal} handleCloseInfoModal={handleCloseInfoModal} />
    </div>
  );
};

export default DealOfMonth;